import { render, staticRenderFns } from "./Pendanaan-Mobile.vue?vue&type=template&id=1a96f19b&scoped=true"
import script from "./Pendanaan-Mobile.vue?vue&type=script&lang=js"
export * from "./Pendanaan-Mobile.vue?vue&type=script&lang=js"
import style0 from "./Pendanaan-Mobile.vue?vue&type=style&index=0&id=1a96f19b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96f19b",
  null
  
)

export default component.exports